import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var ConversationService = /** @class */ (function () {
    function ConversationService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.serviceUrl = this.env.servicePath;
    }
    ConversationService.prototype.converse = function (query) {
        var path = this.serviceUrl + "Converse/" + query;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    ConversationService.prototype.saveUtteranceForJob = function (utterance, jobId) {
        var path = this.serviceUrl + "SaveUtteranceForJob/" + jobId + "/" + utterance;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    ConversationService.prototype.saveUtteranceForPersonalizedView = function (utterance, selectedViewId) {
        var path = this.serviceUrl + "SaveUtteranceForPersonalizedView/" + selectedViewId + "/" + utterance;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    ConversationService.prototype.saveUtteranceForEPIC = function (utterance, epicId) {
        var path = this.serviceUrl + 'SaveUtteranceForEPIC/' + epicId + '/' + utterance;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true',
                'User': this.globals.Session.Session.UserId, 'Session': this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    ConversationService.prototype.saveUserTagForEPIC = function (tagValue, documentId) {
        var path = this.serviceUrl + 'SaveUserTagForEPIC/' + documentId + '/' + tagValue;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true',
                'User': this.globals.Session.Session.UserId, 'Session': this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    ConversationService.prototype.saveMetadataForEPIC = function (templateType, epicId) {
        var path = this.serviceUrl + 'SaveMetadataForEPIC/' + templateType + '/' + epicId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true',
                'User': this.globals.Session.Session.UserId, 'Session': this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    ConversationService.prototype.getObjects = function (tag) {
        var path = this.serviceUrl + "GetObjects/" + tag;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ConversationService.prototype.getSuggestions = function (key, keyword) {
        var path = this.serviceUrl + "GetSuggestions/" + key + "?param=" + keyword;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ConversationService.ngInjectableDef = i0.defineInjectable({ factory: function ConversationService_Factory() { return new ConversationService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: ConversationService, providedIn: "root" });
    return ConversationService;
}());
export { ConversationService };
